module.exports = __webpack_public_path__ + "static/media/vase6.49d91c9d.jpg";